import { createAction } from '@reduxjs/toolkit';
import { UtmTags } from '../../entities';

export const userUtmTagsUpdated = createAction<UtmTags>('userUtmTags/UPDATED');
